import { AppFunctionComponent } from "../../../types"
import React from "react"
import { linksMapId } from "../../../components/common/skip-links-navigation.component"
import { NeutralTextLink } from "../../../ui/components/link/link.component"
import { Path } from "../../constants/routes"
import { Menu as MenuType } from "../../types/menu.interface"
import Copyrights from "../copyrights/copyrights.component"
import Social from "../social/social.component"
import { FooterSection, Menu, MenuColumn, SubmenuItem } from "./footer.styled"

type FooterMenuProps = {
  logoPath: Path
  languageChange: (e: React.ChangeEvent<HTMLSelectElement>) => void
  languageValue: string
}

const FooterMenu: AppFunctionComponent<MenuType & FooterMenuProps> = ({
  navigationItems,
  logoPath,
}) => {
  return (
    <footer>
      <FooterSection items={navigationItems}>
        <Social logoPath={logoPath} />
        <Menu aria-label="All pages" id={linksMapId}>
          {navigationItems.map((menu) => (
            <MenuColumn items={navigationItems} key={menu.path}>
              <li>
                <NeutralTextLink to={menu.path}>
                  {menu.displayName}
                </NeutralTextLink>
              </li>
              {menu.subnavigationItem &&
                menu.subnavigationItem.map((submenu) => (
                  <li key={submenu.path}>
                    <SubmenuItem to={submenu.path}>
                      {submenu.displayName}
                    </SubmenuItem>
                  </li>
                ))}
            </MenuColumn>
          ))}
        </Menu>
        <Copyrights />
      </FooterSection>
    </footer>
  )
}

export default FooterMenu
